import * as React from "react"
import AlertBar from "components/partials/alert-bar"
import Header from "components/frame/header"
import Breadcrumbs from "components/frame/breadcrumbs"
import Footer from "components/frame/footer"
import { useSiteSectionNavigationData } from "hooks/use-site-section-navigation-data"
import { NavSection } from "types/nav-section"
import { BreadcrumbData } from "types/breadcrumb-data"
import { SignatureEventClass } from "types/signature-event-class"
import { useGlobalAlert } from "hooks/use-global-alert"
import TestErrorComponent from "components/test-error-component"

// absolute import path set to src. This is a custom setting in gatsby-node.ts
// TODO: Determine solution to avoid duplicate img folders, one for static files used by gatsby and one used by gatsby-plugin-react-svg
import 'less/style.less'

interface LayoutProps extends React.PropsWithChildren {
    signatureTheme?: SignatureEventClass;
    DocumentationNav?: React.ReactNode;
    navSection?: NavSection;
    breadcrumbs?: BreadcrumbData[];
    currentPageId?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, signatureTheme = "sig-main", navSection, breadcrumbs, DocumentationNav, currentPageId }) => {
    const navData = useSiteSectionNavigationData();
    const mainNavData = navSection ? navData[navSection] : undefined;
    const globalAlert = useGlobalAlert();
    return (
        <div className="site-wrapper">
            <a className="skip-to-content-link" href="#main">Skip to main content</a>
            {DocumentationNav}
            {globalAlert !== null &&
                <AlertBar
                    id={globalAlert.id}
                    modifierClass=""
                    type={globalAlert.iconName ?? 'info'}
                    headline={globalAlert.title ?? ''}
                    content={globalAlert.text ?? ''} 
                    link={globalAlert.link ?? undefined}
                    startDate={globalAlert.startDatetime ? new Date(globalAlert.startDatetime) : undefined}
                    endDate={globalAlert.endDatetime ? new Date(globalAlert.endDatetime) : undefined}
                    isDismissable={globalAlert.isDismissible ?? false}
                    isGlobal={true}
                />
            }
            <Header mainNavData={mainNavData} currentPageId={currentPageId} />
            <Breadcrumbs data={breadcrumbs} />
            <main id="main" className={`site-main ${signatureTheme}`}>
                {children}
                {/* Uncomment to test Rollbar error tracking */}
                {/* <TestErrorComponent /> */}
            </main>
            <Footer />
        </div>
    )
}


export default Layout